export const name = '_dai'
export const displayName = 'DAI'
export const ticker = `${name}_DAI`
export const displayTicker = 'DAI'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 18,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = [
  'mcd',
  'dai_matic_845af41b',
  'dai_bsc_709f85b7',
  'dai_optimism_6343ae93',
]
